var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 2.5H3.33333C2.8731 2.5 2.5 2.8731 2.5 3.33333V8.33333C2.5 8.79357 2.8731 9.16667 3.33333 9.16667H8.33333C8.79357 9.16667 9.16667 8.79357 9.16667 8.33333V3.33333C9.16667 2.8731 8.79357 2.5 8.33333 2.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 2.5H11.6667C11.2064 2.5 10.8333 2.8731 10.8333 3.33333V8.33333C10.8333 8.79357 11.2064 9.16667 11.6667 9.16667H16.6667C17.1269 9.16667 17.5 8.79357 17.5 8.33333V3.33333C17.5 2.8731 17.1269 2.5 16.6667 2.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 10.8333H3.33333C2.8731 10.8333 2.5 11.2064 2.5 11.6667V16.6667C2.5 17.1269 2.8731 17.5 3.33333 17.5H8.33333C8.79357 17.5 9.16667 17.1269 9.16667 16.6667V11.6667C9.16667 11.2064 8.79357 10.8333 8.33333 10.8333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.8333H11.6667C11.2064 10.8333 10.8333 11.2064 10.8333 11.6667V16.6667C10.8333 17.1269 11.2064 17.5 11.6667 17.5H16.6667C17.1269 17.5 17.5 17.1269 17.5 16.6667V11.6667C17.5 11.2064 17.1269 10.8333 16.6667 10.8333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryAll);
export default __webpack_public_path__ + "static/media/category-all.a439514a584d9e6d635937f28654bb70.svg";
export { ForwardRef as ReactComponent };